import { Navigate, Outlet } from 'react-router-dom';

/**
 * Client-side guard for admin routes.
 *
 * Rails already enforces admin access server-side via `authorize_admin!` in
 * PlatformWebController — this guard is defense-in-depth to prevent non-admin
 * users from reaching broken admin pages via SPA client-side navigation.
 *
 * Reads `isAdmin` from the `__CURRENT_USER__` context injected by Rails.
 */
function RequireAdmin() {
  const currentUser = (window as any).__CURRENT_USER__;
  const isAdmin = currentUser?.isAdmin === true;

  return isAdmin ? <Outlet /> : <Navigate to="/" replace />;
}

export default RequireAdmin;
